import { DmCryptoEngine, createHttpTransport } from '@comms/crypto';
import { rawApi } from './api';
import { SecureStore } from './secureStore';
import { useStore } from '../store';

let engine: DmCryptoEngine | null = null;
let starting: Promise<DmCryptoEngine> | null = null;

function deviceName() {
  const ua = navigator.userAgent;
  const browser = /Firefox\//.test(ua)
    ? 'Firefox'
    : /Edg\//.test(ua)
      ? 'Edge'
      : /Chrome\//.test(ua)
        ? 'Chrome'
        : /Safari\//.test(ua)
          ? 'Safari'
          : 'Browser';
  const os = /Windows/.test(ua)
    ? 'Windows'
    : /Android/.test(ua)
      ? 'Android'
      : /iPhone|iPad/.test(ua)
        ? 'iOS'
        : /Mac OS/.test(ua)
          ? 'macOS'
          : /Linux/.test(ua)
            ? 'Linux'
            : '';
  return os ? `${browser} on ${os}` : browser;
}

export function getEngine(): DmCryptoEngine | null {
  return engine;
}

/** Initialize this browser's E2EE device. Safe to call repeatedly. */
export function startE2ee(userId: string): Promise<DmCryptoEngine> {
  if (engine) return Promise.resolve(engine);
  starting ??= (async () => {
    // WebCrypto is only exposed on secure origins (HTTPS or localhost). Refuse to run
    // encrypted DMs anywhere else rather than fall back to anything weaker.
    if (!globalThis.isSecureContext || !globalThis.crypto?.subtle)
      throw new Error('Encrypted messages need HTTPS (WebCrypto is unavailable on this page)');
    const store = await SecureStore.open(userId);
    const e = new DmCryptoEngine(createHttpTransport(rawApi), store, userId, deviceName());
    await e.init();
    engine = e;
    const dms = Object.values(useStore.getState().channels).filter((c) => c.guildId === null);
    for (const c of dms)
      void e.sync(c.id).catch((err: unknown) => console.warn('e2ee sync failed', c.id, err));
    return e;
  })().catch((err: unknown) => {
    starting = null;
    throw err;
  });
  return starting;
}

export function stopE2ee() {
  engine = null;
  starting = null;
}

export function syncDm(channelId: string) {
  if (!engine) return;
  void engine
    .sync(channelId)
    .catch((err: unknown) => console.warn('e2ee sync failed', channelId, err));
}
